export default __webpack_public_path__ + "static/media/Dazzed-Bold.62d7c869.otf";